export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ../~/rmc-feedback/es/index.js
// module id = 1548
// module chunks = 0